import { useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import { getEdition, getTemplate } from '../restapi/preview';


// read the docId from url like /2021-05-12   (when empty use today)
export function useEditionId() {
	const {id} = useParams<{ id: string }>();
	return parseInt(id || '0');
}

export function useTemplate() {
	const edId = useEditionId();
	const templateQuery = useQuery(['template', edId], () => getTemplate(edId));
	return templateQuery.data;
}

export function useCurrentEd() {
	const edId = useEditionId();
	const edQuery = useQuery(['edition', edId], () => getEdition(edId));
	return edQuery.data;
}
